export { default as CmsLogos } from './CmsLogos';
